import React from 'react'
import { Select } from '../Class/Select'
import { useSelector } from 'react-redux'

const SelectGST = ({defaultValue,onSelect,placeholder,disabled=false,BajajElec_ZRNT_check=false}) => {
    const tenant = useSelector(state=>state.auth.config.tenant);    
    const excludeForAPHL = tenant === 'APHL';
    
    return (
        <Select
            value={defaultValue}
            items={[
                {
                    value: 0,
                    label: 0,
                },
                ...(!BajajElec_ZRNT_check && !excludeForAPHL) ? [{
                    value: 3,
                    label: 3,
                }] : [],
                ...(!BajajElec_ZRNT_check) ? [{
                    value: 5,
                    label: 5,
                }] : [],
                ...(!BajajElec_ZRNT_check && !excludeForAPHL) ? [{
                    value: 8,
                    label: 8,
                },{
                    value: 9,
                    label: 9,
                }] : [],
                ...(!BajajElec_ZRNT_check) ? [{
                    value: 12,
                    label: 12,
                }] : [],
                {
                    value: 18,
                    label: 18,
                },
                ...(!BajajElec_ZRNT_check) ? [{
                    value: 28,
                    label: 28,
                },
                {
                    value: 40,
                    label: 40
                }] : [],
            ]}
            disabled={disabled}
            placeholder={placeholder?placeholder:"Select Tax"}
            select={onSelect}
        />
    )
}

export default SelectGST